import type { INote, IScoreboard } from "../types/INote";
import type { IPageData } from "../types/IPageData";
import { fetchScoreboardData } from "./api";

interface Image {
  url: URL;
  width: number;
  height: number;
}

interface Author {
  name: string;
  url: URL;
}

export class StructuredDataFragmentsUniversal {
  static async fetchData({ articleId }: { articleId: IPageData["articleId"] }) {
    return new StructuredDataFragmentsUniversal({ articleId });
  }

  articleId: IPageData["articleId"];
  private constructor({ articleId }: { articleId: IPageData["articleId"] }) {
    this.articleId = articleId;
    /**
     * @TODO: This is place for storing async data coming from API,
     *        For now, we gather structured data throughout Document.
     *        Not great, not terrible ;)
     */
  }

  DEFAULT_IMAGE_LOGO: Image = {
    url: new URL(`${window.location.origin}/logos/0.png`),
    width: 200,
    height: 200,
  };

  getTitle(): string {
    return document.querySelector("h1")?.textContent?.trim() ?? "";
  }

  getHeadline(): string {
    return document.title.trim();
  }

  getDescription(): string {
    return document.querySelector('meta[name="Description"]')?.getAttribute("content")?.trim() ?? "";
  }

  getURL(): URL {
    return new URL(window.location.toString());
  }

  getCoverageStartTime(): Date {
    return new Date(document.querySelector(".article_date time")?.getAttribute("datetime")?.trim() ?? Date.now());
  }

  getCoverageEndTime({ notes = [] }: { notes?: INote[] } = {}): Date | undefined {
    if (!window.gazeta_pl.rtcIsLive && notes.length > 0) {
      return new Date(notes[0].publicationDate);
    }
  }

  getDatePublished() {
    return new Date(document.querySelector(".article_date time")?.getAttribute("datetime")?.trim() ?? Date.now());
  }

  getDateModified({ notes = [] }: { notes?: INote[] } = {}): Date | undefined {
    if (notes.length > 0) {
      return new Date(notes[0].publicationDate);
    }
  }

  getCoverImage(): Image {
    const coverImageElement: HTMLImageElement | null = document.querySelector(
      "#article-gallery .article-gallery-picture__image"
    );

    if (coverImageElement) {
      const PHOTO_FORMAT_REGEX = /(z\d+)[A-Z]+/;

      return {
        url: new URL(coverImageElement.getAttribute("src")!.replace(PHOTO_FORMAT_REGEX, "$1" + "IEG")),
        width: 1200,
        height: 675,
      };
    }

    return this.DEFAULT_IMAGE_LOGO;
  }

  getAuthors(): Author[] {
    return [...document.querySelectorAll('.article_author a[rel="author"]')]
      .filter((i) => {
        try {
          new URL(i.getAttribute("href")?.trim() ?? "");
          return true;
        } catch (e) {
          return false;
        }
      })
      .map((i) => ({
        name: i.textContent!.trim(),
        url: new URL(i.getAttribute("href")!.trim()),
      }));
  }

  getPortalName(): string {
    return window.location.host;
  }

  getPortalLogo(): Image {
    const portalLogo: HTMLImageElement | null = document.querySelector("img.serviceLogo__img");

    if (portalLogo) {
      return {
        url: new URL(portalLogo.getAttribute("src")!),
        width: portalLogo.width,
        height: portalLogo.height,
      };
    }

    return this.DEFAULT_IMAGE_LOGO;
  }
}

export class StructuredDataFragmentsSport {
  static async fetchData({ articleId }: { articleId: IPageData["articleId"] }) {
    const dataScoreboard = await fetchScoreboardData({ articleId });
    return new StructuredDataFragmentsSport({ dataScoreboard });
  }

  dataScoreboard: IScoreboard;
  private constructor({ dataScoreboard }: { dataScoreboard: IScoreboard }) {
    this.dataScoreboard = dataScoreboard;
    /**
     * @TODO: This is place for storing async data coming from API,
     *        For now, we gather structured data throughout Document.
     *        Not great, not terrible ;)
     */
  }

  getLivePlace(): string {
    // @TODO
    return "";
  }

  getHomeTeam(): string {
    return this.dataScoreboard.matchHeaders[0].teamLeft.name;
  }

  getAwayTeam(): string {
    return this.dataScoreboard.matchHeaders[0].teamRight.name;
  }
}
